import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'MultiInputItem',

  props: {
    // 初期値（v-modelとして利用する）
    value: {
      type: Object,
      required: false,
      default: null,
    },
    // マルチアイテムの総数
    count: {
      type: Number,
      required: true,
    },
    // インデックス
    index: {
      type: Number,
      required: true,
    },

    // プレースホルダー
    namePlaceholder: {
      type: String,
      required: false,
      default: null,
    },
    valuePlaceholder: {
      type: String,
      required: false,
      default: null,
    },

    // valueタイプがtextの入力最大数を指定する場合に指定
    nameLimit: {
      type: Number,
      required: false,
      default: null,
    },
    valueLimit: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data () {
    return {
      input: {
        appName: null,
        packageName: null,
      },
    };
  },

  mounted () {
    if (this.value) {
      this.input.appName = this.value.appName;
      this.input.packageName = this.value.packageName;
    }
  },

  watch: {
    value(to) {
      this.$set(this, 'input', JSON.parse(JSON.stringify(to)));
    },
    'input.appName': function (to) {
      if (to && this.nameLimit !== null) {
        this.input.appName = Validator.charLimit(to, this.nameLimit)
      }
    },
    'input.packageName': function (to) {
      if (to && this.valueLimit !== null) {
        this.input.packageName = Validator.charLimit(to, this.valueLimit)
      }
    },
  },

  methods: {
    onChange() {
      this.$emit('input', this.input);
    },
    deleteItem() {
      if (this.count === 1 && this.index === 0) {
        this.$set(this, 'input', {
          appName: null,
          packageName: null,
        })
      } else {
        this.$emit('delete', this.index);
      }
    }
  }
}
